import { Document } from '@react-pdf/renderer';

import { PDFProvider, PDFProviderType } from './PDFProvider';
import { siteQuoteDocuments } from './SiteQuoteDocuments';

type PDFDocumentProps = PDFProviderType;

export function PDFDocument({ siteCode, ...props }: PDFDocumentProps) {
  const QuoteDocument = siteQuoteDocuments[siteCode];

  return (
    <Document>
      <PDFProvider {...props} siteCode={siteCode}>
        <QuoteDocument />
      </PDFProvider>
    </Document>
  );
}
